export const hasGreaterThan14Char = (str) => str.length >= 14;
export const hasNumber = (str) => /\d/.test(str);
export const hasLowerCase = (str) => str.toUpperCase() !== str;
export const hasUpperCase = (str) => str.toLowerCase() !== str;

export const validPasswordCreate = (str) =>
  str.length >= 14 && hasLowerCase(str) && hasUpperCase(str) && hasNumber(str);
